import { Component } from '@angular/core';
import {
  CellRendererComponent
} from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { Column } from '@valg-shared/components/table/table/column';
@Component({
  selector: 'valg-dk-responsive-bar-chart-renderer',
  templateUrl: './responsive-bar-chart-renderer.component.html'
})
export class ResponsiveBarChartRendererComponent implements CellRendererComponent {
  value = "";
  percentage!: number;
  breakpoint = "d-md-none";
  description?: string;

  public init(data: unknown, column: Column): void {
    this.value = getValueAt(data, column.path);
    if(column.metadata?.responsiveRenderer){
      let percentage = getValueAt(data, column.metadata?.responsiveRenderer?.path);
      if(percentage){
        this.percentage = percentage;
      }

      let breakpoint = column.metadata.responsiveRenderer.breakpoint;
      if(breakpoint !== ""){
        this.breakpoint = 'd-'+breakpoint+'-none';
      } else{
        this.breakpoint = "";
      }
    }
    let description = column.metadata?.rowDescriptionFunction;
    if(description){
      description(data).subscribe((result) => {
        this.description = result;
      })
    }
  }

}
